import { Clock } from "./clock.js";
import { omit } from "es-toolkit";
//#region src/engine/context.ts
function createEngineContext(ctx) {
	return {
		...omit(ctx, ["remote"]),
		clock: new Clock()
	};
}
//#endregion
export { createEngineContext };
